import React from 'react';
import './PurchaseHistoryItem.css';
import PageButton from '../elements/PageButton/PageButton';
import {resolvePurchaseItemDisplay} from '../../utils/purchases/resolvePurchaseItemDisplay';
import {getFormattedPrice} from '../../utils/price/getFormattedPrice';
import {formatMatchDate} from '../../utils/date/formatMatchDate';

function PurchaseHistoryItem({purchase, showUserName, onClick, pageId, buttonId}) {
  const {name, iconPath} = resolvePurchaseItemDisplay(purchase.itemType, purchase.itemId);
  const isNumens = purchase.currency === 'numens';

  const content = (
    <>
      {iconPath && (
        <img className="purchase-history-icon" src={iconPath} alt={name} title={name}/>
      )}
      <div className="purchase-history-info">
        <span className="purchase-history-name">{name}</span>
        {showUserName && purchase.userName && (
          <span className="purchase-history-user-name">{purchase.userName}</span>
        )}
      </div>
      <span className="purchase-history-quantity">{`×${purchase.quantity}`}</span>
      <div className="purchase-history-price">
        <span className={isNumens ? 'text-coins' : 'text-crystals'}>
          {getFormattedPrice(purchase.totalPrice)}
        </span>
        <img
          className="purchase-history-price-icon"
          src={isNumens ? '/img/icons/numens.png' : '/img/icons/crystal.png'}
          alt={isNumens ? 'Нумены' : 'Кристаллы'}
        />
      </div>
      <span className="purchase-history-date">{formatMatchDate(purchase.createdAt)}</span>
    </>
  );

  if (onClick) {
    return (
      <PageButton
        className="purchase-history-item purchase-history-item_clickable"
        onClick={onClick}
        pageId={pageId}
        buttonId={buttonId}
      >
        {content}
      </PageButton>
    );
  }

  return (
    <div className="purchase-history-item">
      {content}
    </div>
  );
}

export default PurchaseHistoryItem;
